import React from 'react';
import BensServicosTemplate from '@/components/templates/BensServicosTemplate';

function BnesServicosPage() {
  return <BensServicosTemplate />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default BnesServicosPage;
